import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { withRouter } from "../../../utils/withRouter";
import { Breadcrumb } from "../../../components/Breadcrumb";
import BloodTesting from "../../../components/BloodTesting/BloodTesting";
import { DonorProfile } from "../../../components/Donors";
import CollectionPreview from "./CollectionPreview";
import { Inventories } from "../../../components/inventory";
import Separations from "../../../components/Production/ComponentSeparation/Separations";
import { Transformations } from "../../../components/Production/ComponentTransformation";
import ShipmentReport from "../../../components/Requests/shipping/report";
import MyRequests from "../../../components/Requests/MyRequests";
import { BloodUsage } from "../../../components/BloodUsage";
import { getStorage } from "../../../utils/storage";
import { defineRole } from "../../../utils/handleAccessRoles";
import {
  ROLE_BLOOD_TEST,
  ROLE_BLOOD_USAGE,
  ROLE_COLLECTIONS,
  ROLE_COMPONENT_SEPARATION,
  ROLE_COMPONENT_TRANSFORMATION,
  ROLE_DONORS,
  ROLE_LABELING,
  ROLE_REQUEST,
} from "../../../constants/ROLES";

class DonationScreen extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  render() {
    let tabOptions = [];
    const roles = this.state?.user?.accessRole || [];

    const canAccessCollection = defineRole({
      roles,
      menu: ROLE_COLLECTIONS,
      operation: "read",
    });
    const canAccessDonor = defineRole({
      roles,
      menu: ROLE_DONORS,
      operation: "read",
    });

    const canBloodTest = defineRole({
      roles,
      menu: ROLE_BLOOD_TEST,
      operation: "read",
    });

    const canAccessSeparation = defineRole({
      roles,
      menu: ROLE_COMPONENT_SEPARATION,
      operation: "read",
    });

    const canAccessTransformation = defineRole({
      roles,
      menu: ROLE_COMPONENT_TRANSFORMATION,
      operation: "read",
    });
    const canAccessLabeling = defineRole({
      roles,
      menu: ROLE_LABELING,
      operation: "read",
    });
    const canAccessRequest = defineRole({
      roles,
      menu: ROLE_REQUEST,
      operation: "read",
    });
    const canAccessBloodUsage = defineRole({
      roles,
      menu: ROLE_BLOOD_USAGE,
      operation: "read",
    });

    if (canAccessCollection) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].donation_information,
        data: (
          <CollectionPreview donationId={this.props.routeParams.donationId} />
        ),
      });
    }

    if (canAccessDonor) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].donor_information,
        data: <DonorProfile donorId={this.props.routeParams.donorId} />,
      });
    }

    if (canBloodTest) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].blood_testing,
        data: <BloodTesting {...this.props.routeParams} isSearch />,
      });
    }

    if (canAccessSeparation) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].component_separation,
        data: <Separations {...this.props.routeParams} type="separation" />,
      });
    }

    if (canAccessTransformation) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].component_transformation,
        data: <Transformations {...this.props.routeParams} />,
      });
    }

    if (canAccessLabeling) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].labeling,
        data: (
          <Inventories
            {...this.props.routeParams}
            status="labelled"
            allowStatusWithDonation
            showActualLabel
          />
        ),
      });
    }

    if (canAccessRequest) {
      tabOptions.push(
        {
          title: language[this.props.defaultLanguage].shipments,
          data: (
            <ShipmentReport donationId={this.props.routeParams.donationId} />
          ),
        },
        {
          title: language[this.props.defaultLanguage].blood_requests,
          data: (
            <MyRequests
              donationId={this.props.routeParams.donationId}
              donationNumber={this.props.routeParams.donationNumber}
            />
          ),
        },
      );
    }

    if (canAccessBloodUsage) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].blood_usage,
        data: (
          <BloodUsage donationNumber={this.props.routeParams.donationNumber} />
        ),
      });
    }

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Breadcrumb
              homeUrl="/dashboard/home"
              data={[
                {
                  name: language[this.props.defaultLanguage].donors,
                  url: "/dashboard/donors",
                },
                {
                  name: language[this.props.defaultLanguage]
                    .donation_information,
                  url: `/dashboard/donors/${this.props.routeParams.donorId}`,
                },
                {
                  name: this.props.routeParams.donationNumber,
                  active: true,
                },
              ]}
            />
            {/* <DonorProfile donorId={this.props.routeParams.donorId} /> */}
            {/* <Tabs
              options={tabOptions}
              mountOnEnter
              unmountOnExit={false}
              vertical
            /> */}
            <BloodTesting {...this.props.routeParams} isSearch />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(DonationScreen));
